const dummydata = [
  {
    id: 1,
    title: "Week 1: HTML and CSS",
    imageUrl: "https://cdn-icons-png.flaticon.com/512/921/921594.png",
    week: 1,
  },
  {
    id: 2,
    title: "Week 2: JavaScript",
    imageUrl:
      "https://cdn-icons-png.flaticon.com/512/2721/2721272.png",
    week: 2,
  },
  {
    id: 3,
    title: "Week 3: UX and UI",
    imageUrl:
      "https://cdn-icons-png.flaticon.com/512/1260/1260243.png",
    week: 3,
  },
  {
    id: 4,
    title: "Week 4: Backend",
    imageUrl:
      "https://cdn-icons-png.flaticon.com/512/1073/1073436.png",
    week: 4,
  },
  {
    id: 5,
    title: "Week 5: Databases",
    imageUrl:
      "https://cdn-icons-png.flaticon.com/512/2906/2906274.png",
    week: 5,
  },
  {
    id: 6,
    title: "Week 6: Testing",
    imageUrl:
      "https://cdn-icons-png.flaticon.com/512/2942/2942789.png",
    week: 6,
  },
];
export default dummydata;